import axios from "axios";
import React, {useEffect, useState} from "react";
import {useParams} from 'react-router-dom';
import {baseUrl, userLocation} from '../Univ.js'
function MinInvoiceOp(props) {
    const {sale_min} = useParams();
    const [minbillData, setminBillData] = useState([]);
    const [hospData, setHospData] = useState([]);
    useEffect(() => {
        try {
            axios.get(baseUrl + 'min-invoice-op/' + sale_min)
                .then(function (response) {
                    setminBillData(response.data);
                });
        } catch (error) {
            console.log(error);
        }
        try {
            axios.get(baseUrl + "view-hospital/" + userLocation + "/").then(function (response) {
                setHospData(response.data);
            });
        } catch (error) {
            console.log(error);
        }
    }, []);
    const handlePrint = () => {
        const printContents = document.getElementById('invoice-print').innerHTML;
        const originalContents = document.body.innerHTML;
        document.body.innerHTML = printContents;
        window.print();
        setTimeout(() => {
            window.location.reload();
        }, 1000);
        document.body.innerHTML = originalContents;
    };
    function numberToWords(num) {
        const units = ['zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine'];
        const teens = ['eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen'];
        const tens = ['', 'ten', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];
        const scales = ['', 'thousand', 'million', 'billion', 'trillion'];
        function convertThreeDigitsLessThanThousand(num) {
            if (num === 0) return '';
            let result = '';
            const hundredsDigit = Math.floor(num / 100);
            const remainder = num % 100;
            if (hundredsDigit > 0) {
                result += `${units[hundredsDigit]} hundred`;
            }
            if (remainder > 0) {
                if (result) result += ' and ';
                if (remainder < 10) {
                    result += units[remainder];
                } else if (remainder < 20 && remainder !== 10) {
                    result += teens[remainder - 11];
                } else {
                    const tensDigit = Math.floor(remainder / 10);
                    const onesDigit = remainder % 10;
                    result += tens[tensDigit];
                    if (onesDigit > 0) {
                        result += `-${units[onesDigit]}`;
                    }
                }
            }
            return result;
        }
        if (num === 0) {
            return 'zero rupees only';
        }
        if (num < 0) {
            return `negative ${numberToWords(Math.abs(num))}`;
        }
        const parts = num.toString().split('.');
        let integerPart = parseInt(parts[0], 10);
        const decimalPart = parts[1] ? parseInt(parts[1].substring(0, 2), 10) : 0;
        let words = '';
        let scaleIndex = 0;
        while (integerPart > 0) {
            const chunk = integerPart % 1000;
            if (chunk > 0) {
                const chunkWords = convertThreeDigitsLessThanThousand(chunk);
                if (scales[scaleIndex]) {
                    words = `${chunkWords} ${scales[scaleIndex]} ${words}`;
                } else {
                    words = `${chunkWords} ${words}`;
                }
            }
            integerPart = Math.floor(integerPart / 1000);
            scaleIndex++;
        }
        words = words.trim();
        if (decimalPart > 0) {
            words += ' and ';
            if (decimalPart < 10) {
                words += `${units[decimalPart]} paisa`;
            } else if (decimalPart < 20 && decimalPart !== 10) {
                words += `${teens[decimalPart - 11]} paisa`;
            } else {
                const tensDigit = Math.floor(decimalPart / 10);
                const onesDigit = decimalPart % 10;
                words += `${tens[tensDigit]}`;
                if (onesDigit > 0) {
                    words += `-${units[onesDigit]}`;
                }
                words += ' paisa';
            }
        }
        words += ' rupees only';
        return words.trim();
    }
    return (
        <section>
            <div>
                {minbillData.map((row, index) =>
                    <div id="invoice-print">
                        <div
    style={{
        width: "100%",
        margin: 0,
        padding: 0,
        overflow: "hidden",
        lineHeight: 0
    }}
>
    {hospData.map((hospital) => (
        <img
            key={hospital.id}
            src={hospital.logo}
            alt="Hospital Header"
            style={{
                width: "100%",
                height: "110px",
                display: "block",
                margin: 0,
                padding: 0,
                border: "none",
                objectFit: "fill"
            }}
        />
    ))}
</div>

<div
    style={{
        width: "100%",
        margin: "8px 0 0 0",
        padding: "8px 12px",
        boxSizing: "border-box",
        borderTop: "1px solid #333",
        borderBottom: "1px solid #333",
        fontSize: "14px",
        lineHeight: "1.5"
    }}
>
    <div
        style={{
            display: "flex",
            width: "100%",
            alignItems: "flex-start"
        }}
    >
        <div
            style={{
                width: "55%",
                paddingRight: "15px",
                boxSizing: "border-box",
                borderRight: "1px solid #999"
            }}
        >
            <div style={{ marginBottom: "3px" }}>
                <strong>Name :</strong>&nbsp;
                {row.pat.patient}
            </div>

            <div style={{ marginBottom: "3px" }}>
                <strong>PID :</strong>&nbsp;
                {row.pat.pat_id}
            </div>

            <div>
                <strong>Consultant :</strong>&nbsp;
                Dr. {row.cons.consultant}
            </div>
        </div>

        <div
            style={{
                width: "45%",
                paddingLeft: "15px",
                boxSizing: "border-box"
            }}
        >
            <div style={{ marginBottom: "3px" }}>
                <strong>Invoice No # :</strong>&nbsp;
                {row.min_invoice}
            </div>

            <div style={{ marginBottom: "3px" }}>
                <strong>Date :</strong>&nbsp;
                {row.min_date}
            </div>

            <div>
                <strong>
                    {row.min_pmode
                        ? row.min_pmode.charAt(0).toUpperCase() +
                          row.min_pmode.slice(1)
                        : ""} Receipt
                </strong>
            </div>
        </div>
    </div>
</div>
                        <div>
                            <table border="2" rules="rows" cellpadding="3" className="text-justify mt-4" width="100%">
                                <thead>
                                <tr style={{backgroundColor: '#1bc5ce', color: 'white'}}>
                                    <th align="left">S.No</th>
                                    <th align="left">Particulars</th>
                                    <th align="left">Amount</th>
                                </tr>
                                </thead>
                                <tbody>
                                {row.min_test.split(',').map((test, subIndex) => (
                                    <tr key={`${index}-${subIndex}`}>
                                        <td style={{
                                            border: "1px solid",
                                            borderColor: "#2194d9"
                                        }}>{index + subIndex + 1}</td>
                                        <td style={{border: "1px solid", borderColor: "#2194d9"}}>{test.trim()}</td>
                                        <td style={{border: "1px solid", borderColor: "#2194d9"}}><b><i
                                            className="fa fa-inr" aria-hidden="true"></i>&nbsp;
                                            {row.min_amount.split(',')[subIndex].trim()}</b></td>
                                    </tr>
                                ))}
                                <tr>
                                    <td align="center"></td>
                                    <td align="left" style={{border: "1px solid", borderColor: "#2194d9"}}><b>Invoiced
                                        Amount</b></td>
                                    <td align="left" style={{border: "1px solid", borderColor: "#2194d9"}}>
                                        <b><i className="fa fa-inr" aria-hidden="true"></i>&nbsp;{row.min_tot}</b></td>
                                </tr>
                                {row.min_disc != 0 && row.min_disc != "" && (
                                    <tr>
                                        <td align="center"></td>
                                        <td align="left" style={{border: "1px solid", borderColor: "#2194d9"}}><b>Discount
                                            Amount</b></td>
                                        <td align="left" style={{border: "1px solid", borderColor: "#2194d9"}}>
                                            <b style={{color: "red"}}><i className="fa fa-inr"
                                                                         aria-hidden="true"></i>&nbsp;{row.min_disc}</b>
                                        </td>
                                    </tr>
                                )}
                                <tr>
                                    <td align="center"></td>
                                    <td align="left" style={{border: "1px solid", borderColor: "#2194d9"}}><b>Paid
                                        Amount</b></td>
                                    <td align="left" style={{border: "1px solid", borderColor: "#2194d9"}}>
                                        <b><i className="fa fa-inr" aria-hidden="true"></i>&nbsp;{row.min_paid}</b></td>
                                </tr>
                                {row.min_balance != 0 && row.min_balance != "" && (
                                    <tr>
                                        <td align="center"></td>
                                        <td align="left" style={{border: "1px solid", borderColor: "#2194d9"}}><b>Balance
                                            Amount</b></td>
                                        <td align="left" style={{border: "1px solid", borderColor: "#2194d9"}}>
                                            <b><i className="fa fa-inr" aria-hidden="true"></i>&nbsp;{row.min_balance}
                                            </b></td>
                                    </tr>
                                )}
                                </tbody>
                            </table>
                            <p className="mt-2 p-3 text-bold">Received the sum
                                of {numberToWords(parseFloat(row.min_paid))}.</p>
                            <div style={{display: 'flex', justifyContent: 'right', alignItems: 'right'}}>
                                <tr>
                                    <th>{row.cashier}</th>
                                    <br></br>
                                    <th style={{width: "200px", borderTop: "2px solid black"}}>Cashier</th>
                                </tr>
                            </div>
                        </div>
                    </div>
                )}
                <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                    <button
                        style={{padding: '5px 20px', borderRadius: '10px', backgroundColor: '#007bff', color: '#fff'}}
                        onClick={handlePrint}
                    >
                        Print
                    </button>
                </div>
            </div>
        </section>
    );
}
export default MinInvoiceOp;